module.exports = __webpack_public_path__ + "img/ic-50-ahorro.b2254e17.svg";